var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!(!_vm.alertState.visible && !_vm.autoHide))?_c('div',{ref:"test",staticClass:"alert",class:[
    { fixed: _vm.fixed },
    { autoHide: _vm.autoHide },
    { visible: _vm.alertState.visible } ]},[(_vm.errorMessage)?_c('div',{staticClass:"message error"},[_vm._v(_vm._s(_vm.$t(_vm.errorMessage)))]):_vm._e(),(_vm.successMessage)?_c('div',{staticClass:"message success"},[_vm._v(" "+_vm._s(_vm.$t(_vm.successMessage))+" ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }